<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold Информация о складе

  .container.mt-5
    .row
      breadcrumbs(
        :warehouse="warehouse",
        :route="$route",
        :breadcrumbs="[ { name: 'Склады', link: '/inventory/warehouses' }, { name: warehouse.name, update: true }, ]",
        @Update="update"
      )
      router-link(
        :to="`/inventory/warehouses/${warehouse.id}/setup`",
        style="margin-top: 10px"
      ) 
        i.fa.fa-cog.ml-2
    .row.mt-4(v-if="!loaded")
      .col-12
        .loader_holder(style="margin: 0 auto; width: 200px")
          object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
      .col-12.loading_text.text-center {{ loading_steps[loading_step] || 'Загрузка' }}...

    stats(:loaded="loaded", :transactions="transactions")

    employee_compsumption(
      :compsuption="compsuption",
      :employee="employee",
      :items="items",
      :loaded="loaded",
      @loadWarehouseTransactions="loadWarehouseTransactions",
      @applyCompsuption="applyCompsuption",
      @compsuptionSetValue="compsuptionSetValue",
      @removeCompsuption="removeCompsuption"
    )

    items_component(
      :items="items",
      :loaded="loaded",
      :warehouse="warehouse",
      :miniSearch="miniSearch",
      :all_tobaccos="all_tobaccos",
      :suppliers="suppliers",
      @itemTransactionCreated="itemTransactionCreated",
      @Changed="itemChanged",
      @addSupplier="addSupplier"
    )

    //- .row.mt-4(v-if="loaded")
    //-   employee_component(:employee="employee", @Changed="employeeChanged")
    //-   shop_settings(:warehouse_id="$route.params.id", :employee="employee")

    //- employee_logs(
    //-   :employee_logs="employee_logs",
    //-   :loaded="loaded",
    //-   :employee_logs_columns="employee_logs_columns"
    //- )
</template>
<script>
import moment from "moment";
import apiDriver from "../../apiDriver";
let MiniSearch = require("minisearch");
import "sweetalert2/dist/sweetalert2.css";

let copyObject = require("./copyObject").default;

import stats from "./components/stats";
import employee_compsumption from "./components/employee_compsumption";
import items_component from "./components/items";
import breadcrumbs from "./components/breadcrumbs";

let miniSearch = new MiniSearch.default({
  fields: ["name", "dictionary", "barcode"], // fields to index for full-text search
  storeFields: ["id", "name", "netto"], // fields to return with search results
});

export default {
  components: {
    stats,
    employee_compsumption,
    items_component,
    breadcrumbs,
  },

  data() {
    return {
      miniSearch: miniSearch,
      all_tobaccos: [],
      suppliers: [],
      loaded: false,
      loading_step: 0,
      loading_steps: [
        "Загрузка склада",
        "Загрузка сотрудников",
        "Загрузка логов",
        "Загрузка расходов",
        "Загрузка статистики",
      ],
      warehouse: {
        name: "Загрузка склада...", //"Склад #"+this.$route.params.id
      },
      items: [],
      sugs: [],
      compsuption: [],
      employee: [],
      transactions: {
        updating: false,
        list: [],
        arrivals: [],
        compsuptions: [],
        labels: [],
        main_chart: {
          labels: [],
          datasets: [
            {
              data: [],
              label: "Траты",
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "#ff9800",
            },
            {
              data: [],
              label: "Поступления",
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "#4caf50",
            },
            {
              data: [],
              label: "Всего",
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "#9e9e9e",
            },
          ],
        },
      },
    };
  },

  async mounted() {
    console.log("warehouse mounted", this.$route, this.$breadcrumbs);
    await this.update();
  },

  methods: {
    moment,
    async update() {
      this.loaded = false;
      this.loading_step = 0;
      this.loadSuppliers();
      await this.loadWarehouse();
      this.loading_step = 1;
      // uncoment
      await this.loadEmployee();
      // setTimeout(this.loadEmployee, 10000);
      // setTimeout(this.loadEmployeeLogs, 60000);
      this.loading_step = 2;
      await this.loadCompsuption();
      this.loading_step = 3;
      await this.loadWarehouseTransactions();
      this.loaded = true;
    },
    async loadSuppliers() {
      let list = await apiDriver.services.api.get("inventory", "suppliers");
      console.log("suppliers list", list.data.list);
      this.suppliers = list.data.list;
    },
    async loadWarehouse() {
      let id = this.$route.params.id;
      let warehouse = await apiDriver.services.api.get("inventory", "store", {
        id,
      });
      if (!warehouse) return this.$toast.error("Ошибка загрузки склада");
      warehouse = warehouse.data;
      this.warehouse = warehouse.store;
      this.items = warehouse.items;
      this.all_tobaccos = warehouse.tabaccos.map((t) => ({ ...t, id: -t.id }));
      this.all_tobaccos.push(...this.items);
      miniSearch.removeAll();
      miniSearch.addAll(this.all_tobaccos);
      this.miniSearch = miniSearch;
      console.log("all_tobaccos:", this.all_tobaccos);
      console.log("load warehouse:", warehouse);
    },
    async loadCompsuption() {
      let id = this.$route.params.id;
      let compsuption = await apiDriver.services.api.get(
        "inventory",
        "store/getCompsuptions",
        { id }
      );
      if (!compsuption) return this.$toast.error("Ошибка загрузки расхода");
      let data = compsuption.data;
      console.log("compsuption:", data);
      for (let x of data.list) {
        x.removed = false;
        x.loading = false;
      }
      this.compsuption = data.list;
    },
    async loadEmployee() {
      let id = this.$route.params.id;
      let employee = (
        await apiDriver.services.api.get("inventory", "employee/list", { id })
      ).data.list;
      console.log("employee:", employee);
      for (let e of employee) e.secret_code = "- --- ---";
      for (let e of employee) e.removing = false;
      for (let e of employee) e.quick_key_timing = 0;
      this.employee = employee;
    },
    // employee
    employeeChanged({ type, employee_id, new_data }) {
      if (type == "create") {
        // new_data
        this.employee.push(new_data);
      } else if (type == "remove") {
        // employee_id
        this.employee = this.employee.filter((x) => x.id != employee_id);
      }
    },
    async loadWarehouseTransactions() {
      this.transactions.updating = true;
      let id = this.$route.params.id;
      let transactions = (
        await apiDriver.services.api.get("inventory", "store/transactions", {
          id,
        })
      ).data.list;
      let compsuptions = [];
      let arrival = [];
      let labels = [];
      for (let d = moment().add(-14, "days"); d < moment(); d.add(1, "day")) {
        labels.push(d.format("DD.MM"));
        let c = transactions.filter(
          (x) =>
            moment(x.createdAt).format("DD-MM-YYYY") ==
              d.format("DD-MM-YYYY") && x.amount < 0
        );
        let a = transactions.filter(
          (x) =>
            moment(x.createdAt).format("DD-MM-YYYY") ==
              d.format("DD-MM-YYYY") && x.amount > 0
        );
        if (c) {
          compsuptions.push({
            amount: c.reduce((x, y, z) => {
              return y.amount + x;
            }, 0),
            date: d.format("DD-MM-YYYY"),
          });
        } else {
          compsuptions.push({ amount: 0, date: d.format("DD-MM-YYYY") });
        }
        if (a) {
          arrival.push({
            amount: a.reduce((x, y, z) => {
              return y.amount + x;
            }, 0),
            date: d.format("DD-MM-YYYY"),
          });
        } else {
          arrival.push({ amount: 0, date: d.format("DD-MM-YYYY") });
        }
      }

      console.log("transactions", transactions, compsuptions, arrival);
      //charts
      // this.transactions.main_chart.labels this.transactions.main_chart.datasets[0 1 2].data
      let current_all_amount = this.items
        .map((x) => x.amount)
        .reduce((x, y, z) => {
          return parseInt(y) + parseInt(x);
        }, 0);
      let all_amount = [];
      let all_amount_counter = current_all_amount;
      console.log("labels", labels);
      for (let i = labels.length - 1; i >= 0; i--) {
        let c = compsuptions[i];
        let a = arrival[i];
        all_amount[i] = all_amount_counter < 0 ? 0 : all_amount_counter;
        let x = parseInt(all_amount_counter) + Math.abs(c.amount) - a.amount;
        // console.log(
        //   "labels[i], all_amount_counter, c.amount, a.amount, x",
        //   labels[i],
        //   all_amount_counter,
        //   "+",
        //   c.amount,
        //   "-",
        //   a.amount,
        //   "->",
        //   x
        // );
        all_amount_counter = x;
      }
      this.transactions.main_chart.labels = labels;

      this.transactions.main_chart.datasets[0].data = compsuptions.map((x) =>
        Math.abs(x.amount)
      );
      this.transactions.main_chart.datasets[1].data = arrival.map((x) =>
        Math.abs(x.amount)
      );
      this.transactions.main_chart.datasets[2].data = all_amount;

      console.log(
        "transactions",
        this.items.map((x) => x.amount),
        current_all_amount,
        all_amount
      );

      this.transactions.list = transactions;
      this.transactions.compsuptions = compsuptions;
      this.transactions.arrivals = arrival;
      this.transactions.labels = labels;

      this.transactions.updating = false;
    },

    // items
    itemTransactionCreated({ item_id, amount }) {
      let item = this.items.find((x) => x.id == item_id);
      if (item) {
        item.amount = amount;
      }
      this.loadWarehouseTransactions();
    },
    itemChanged({ type, item_id, new_data }) {
      if (type == "create") {
        // new_data
        this.items.push(new_data);
      } else if (type == "update") {
        // item_id new_data
        let o = this.items.find((x) => x.id == item_id);
        copyObject(o, new_data);
      } else if (type == "remove") {
        // item_id
        this.items = this.items.filter((x) => x.id != item_id);
      }
      this.loadWarehouseTransactions();
    },
    async addSupplier(data) {
      console.log("warehouse addSupplier", data);
      let created = await apiDriver.services.api.post(
        "inventory",
        "suppliers/create",
        {
          name: data.name,
          contacts: { phone: data.phone, email: data.email },
        }
      );
      if (!created) {
        this.$toast.error("Ошибка создания поставщика.");
        return;
      }
      this.$toast.success("Поставщик создан!");
      this.loadSuppliers();
    },

    // employee_compsuption
    applyCompsuption({ compsumption_id, item_id, amount }) {
      this.items.find((x) => x.id == item_id).amount -= amount;
      this.removeCompsuption({ compsumption_id });
    },
    removeCompsuption({ compsumption_id }) {
      this.compsuption.find((x) => x.id == compsumption_id).removed = true;
    },
    compsuptionSetValue({ compsumption_id, key, value }) {
      console.log("compsuptionSetValue", compsumption_id, key, value);
      this.compsuption.find((x) => x.id == compsumption_id)[key] = value;
    },
  },
};
</script>
<style scoped lang="scss">
h4 {
  margin-top: 0;
}

div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.warehouse {
  .name {
    font-size: 20pt;
  }
}

@media (prefers-color-scheme: dark) {
  button.styled.red {
    border-color: #666666;
    background-color: #000;
  }
}
</style>
<style lang="scss">
table {
  tr.red {
    td {
      color: red !important;
    }
  }
  tr.orange {
    td {
      color: orange !important;
    }
  }
}
</style>